import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { MessageService } from "../../shared/services/message.service";
import { TranslationKeyConstants } from "../../shared/constants/translation-key-constants";

@Injectable()
export class ValidationErrorInterceptorService implements HttpInterceptor {
  private readonly messageService = inject(MessageService);

  validationErrorMap: Map<string, string> = new Map<string, string>([

    ["CommunicationProfilesDuplicateUniqueParameters", TranslationKeyConstants.communicationProfiles.communicationProfilesDetail.errorMessages.duplicateException],
    ["CommunicationProfilesSecretFunctionalitiesOverlap", TranslationKeyConstants.communicationProfiles.communicationProfilesDetail.errorMessages.secretsOverlap],
    ["CommunicationProfilesNoSingleActiveAgreementReference", TranslationKeyConstants.communicationProfiles.communicationProfilesDetail.errorMessages.singleActiveAgreement],
    ["CodeTranslationsDuplicateUniqueParameters", TranslationKeyConstants.codeTranslation.errorMessages.existingCodeTranslationCombination],
    ["PartnersDuplicateUniqueParameters", TranslationKeyConstants.codeTranslation.errorMessages.existingCodeTranslationCombination],
    ["CodeTranslationsDeletionNotAllowed", TranslationKeyConstants.codeTranslation.errorMessages.deletionNotAllowedCodeTranslation],
    ["PartnersDeletionNotAllowed", TranslationKeyConstants.codeTranslation.errorMessages.deletionNotAllowedCodeTranslation],
    ["SecretsDeleteForeignKey", TranslationKeyConstants.secrets.secretsOverview.errorMessages.deleteForeignKeySecrets],
    ["MessageSettingsDuplicateUniqueParameters", TranslationKeyConstants.messageSettings.messageSettingsDetail.validationMessages.messageSettingCombinationExists],
    ["MessageSettingsDuplicateUniqueParameters", TranslationKeyConstants.messageSettings.messageSettingsDetail.validationMessages.messageSettingCombinationExists],
    ["EntsogCommunicationProfileSecretFunctionalitiesOverlap", TranslationKeyConstants.communicationProfiles.communicationProfilesDetail.errorMessages.secretsOverlap],
    ["EntsogCommunicationProfileNoSingleActiveAgreementReference",TranslationKeyConstants.communicationProfiles.communicationProfilesDetail.errorMessages.atLeastOneActiveAgreement],
    ["EntsogCommunicationProfileDuplicateAgreementReference", TranslationKeyConstants.communicationProfiles.communicationProfilesDetail.errorMessages.duplicateAgreementReference],
  ]);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(tap(() => {
      },
      async (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 400 || err.error === undefined) {
            return;
          }

          let error = err.error;

          if (err.error instanceof Blob) {
            error = JSON.parse(await err.error.text());
          }

          try {
            if (error.errors !== undefined) {
              for (const [key, value] of Object.entries(error.errors)) {
                if (this.validationErrorMap.has(key)) {
                  this.messageService.showErrorMessage(this.validationErrorMap.get(key)!, {params: value as string});
                } else {
                  this.messageService.showErrorMessage((value as string));
                }
              }
            } else {
              this.messageService.showErrorMessage(TranslationKeyConstants.shared.unknownError);
            }
          } catch (e) {
            console.log(e);
          }
        }
      }));
  }
}
